import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import Text from 'antd/lib/typography/Text';

function isEmptyPlaceholder(data) {
  return !!data ? data : 'N.A.';
}

const InfoItem = ({ label, value }) => (
  <Row justify="space-between" gutter={[16, 16]}>
    <Col span={8}>{label}:</Col>
    <Col span={16}>
      <Text strong>{isEmptyPlaceholder(value)}</Text>
    </Col>
  </Row>
);

InfoItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default InfoItem;
